/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { SDKError } from "./sdkerror.js";

/**
 * Rate limited
 */
export type ListServiceAccountsAuthServiceAccountsResponse429ResponseBodyData =
  {
    message: string;
  };

/**
 * Rate limited
 */
export class ListServiceAccountsAuthServiceAccountsResponse429ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: ListServiceAccountsAuthServiceAccountsResponse429ResponseBodyData;

  constructor(
    err: ListServiceAccountsAuthServiceAccountsResponse429ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ListServiceAccountsAuthServiceAccountsResponse429ResponseBody";
  }
}

/**
 * Conflict
 */
export type ListServiceAccountsAuthServiceAccountsResponse409ResponseBodyData =
  {
    message: string;
  };

/**
 * Conflict
 */
export class ListServiceAccountsAuthServiceAccountsResponse409ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: ListServiceAccountsAuthServiceAccountsResponse409ResponseBodyData;

  constructor(
    err: ListServiceAccountsAuthServiceAccountsResponse409ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ListServiceAccountsAuthServiceAccountsResponse409ResponseBody";
  }
}

/**
 * Not found
 */
export type ListServiceAccountsAuthServiceAccountsResponse404ResponseBodyData =
  {
    message: string;
  };

/**
 * Not found
 */
export class ListServiceAccountsAuthServiceAccountsResponse404ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: ListServiceAccountsAuthServiceAccountsResponse404ResponseBodyData;

  constructor(
    err: ListServiceAccountsAuthServiceAccountsResponse404ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ListServiceAccountsAuthServiceAccountsResponse404ResponseBody";
  }
}

/**
 * Forbidden
 */
export type ListServiceAccountsAuthServiceAccountsResponseResponseBodyData = {
  message: string;
};

/**
 * Forbidden
 */
export class ListServiceAccountsAuthServiceAccountsResponseResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: ListServiceAccountsAuthServiceAccountsResponseResponseBodyData;

  constructor(
    err: ListServiceAccountsAuthServiceAccountsResponseResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ListServiceAccountsAuthServiceAccountsResponseResponseBody";
  }
}

/**
 * Unauthorized
 */
export type ListServiceAccountsAuthServiceAccountsResponseBodyData = {
  message: string;
};

/**
 * Unauthorized
 */
export class ListServiceAccountsAuthServiceAccountsResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: ListServiceAccountsAuthServiceAccountsResponseBodyData;

  constructor(
    err: ListServiceAccountsAuthServiceAccountsResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ListServiceAccountsAuthServiceAccountsResponseBody";
  }
}

/**
 * Bad request
 */
export type ListServiceAccountsResponseBodyData = {
  message: string;
};

/**
 * Bad request
 */
export class ListServiceAccountsResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: ListServiceAccountsResponseBodyData;

  constructor(
    err: ListServiceAccountsResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ListServiceAccountsResponseBody";
  }
}

/** @internal */
export const ListServiceAccountsAuthServiceAccountsResponse429ResponseBody$inboundSchema:
  z.ZodType<
    ListServiceAccountsAuthServiceAccountsResponse429ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new ListServiceAccountsAuthServiceAccountsResponse429ResponseBody(
        v,
        { request: v.request$, response: v.response$, body: v.body$ },
      );
    });

/** @internal */
export type ListServiceAccountsAuthServiceAccountsResponse429ResponseBody$Outbound =
  {
    message: string;
  };

/** @internal */
export const ListServiceAccountsAuthServiceAccountsResponse429ResponseBody$outboundSchema:
  z.ZodType<
    ListServiceAccountsAuthServiceAccountsResponse429ResponseBody$Outbound,
    z.ZodTypeDef,
    ListServiceAccountsAuthServiceAccountsResponse429ResponseBody
  > = z.instanceof(
    ListServiceAccountsAuthServiceAccountsResponse429ResponseBody,
  )
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const ListServiceAccountsAuthServiceAccountsResponse409ResponseBody$inboundSchema:
  z.ZodType<
    ListServiceAccountsAuthServiceAccountsResponse409ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new ListServiceAccountsAuthServiceAccountsResponse409ResponseBody(
        v,
        { request: v.request$, response: v.response$, body: v.body$ },
      );
    });

/** @internal */
export type ListServiceAccountsAuthServiceAccountsResponse409ResponseBody$Outbound =
  {
    message: string;
  };

/** @internal */
export const ListServiceAccountsAuthServiceAccountsResponse409ResponseBody$outboundSchema:
  z.ZodType<
    ListServiceAccountsAuthServiceAccountsResponse409ResponseBody$Outbound,
    z.ZodTypeDef,
    ListServiceAccountsAuthServiceAccountsResponse409ResponseBody
  > = z.instanceof(
    ListServiceAccountsAuthServiceAccountsResponse409ResponseBody,
  )
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const ListServiceAccountsAuthServiceAccountsResponse404ResponseBody$inboundSchema:
  z.ZodType<
    ListServiceAccountsAuthServiceAccountsResponse404ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new ListServiceAccountsAuthServiceAccountsResponse404ResponseBody(
        v,
        { request: v.request$, response: v.response$, body: v.body$ },
      );
    });

/** @internal */
export type ListServiceAccountsAuthServiceAccountsResponse404ResponseBody$Outbound =
  {
    message: string;
  };

/** @internal */
export const ListServiceAccountsAuthServiceAccountsResponse404ResponseBody$outboundSchema:
  z.ZodType<
    ListServiceAccountsAuthServiceAccountsResponse404ResponseBody$Outbound,
    z.ZodTypeDef,
    ListServiceAccountsAuthServiceAccountsResponse404ResponseBody
  > = z.instanceof(
    ListServiceAccountsAuthServiceAccountsResponse404ResponseBody,
  )
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const ListServiceAccountsAuthServiceAccountsResponseResponseBody$inboundSchema:
  z.ZodType<
    ListServiceAccountsAuthServiceAccountsResponseResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new ListServiceAccountsAuthServiceAccountsResponseResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type ListServiceAccountsAuthServiceAccountsResponseResponseBody$Outbound =
  {
    message: string;
  };

/** @internal */
export const ListServiceAccountsAuthServiceAccountsResponseResponseBody$outboundSchema:
  z.ZodType<
    ListServiceAccountsAuthServiceAccountsResponseResponseBody$Outbound,
    z.ZodTypeDef,
    ListServiceAccountsAuthServiceAccountsResponseResponseBody
  > = z.instanceof(ListServiceAccountsAuthServiceAccountsResponseResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const ListServiceAccountsAuthServiceAccountsResponseBody$inboundSchema:
  z.ZodType<
    ListServiceAccountsAuthServiceAccountsResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new ListServiceAccountsAuthServiceAccountsResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type ListServiceAccountsAuthServiceAccountsResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const ListServiceAccountsAuthServiceAccountsResponseBody$outboundSchema:
  z.ZodType<
    ListServiceAccountsAuthServiceAccountsResponseBody$Outbound,
    z.ZodTypeDef,
    ListServiceAccountsAuthServiceAccountsResponseBody
  > = z.instanceof(ListServiceAccountsAuthServiceAccountsResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const ListServiceAccountsResponseBody$inboundSchema: z.ZodType<
  ListServiceAccountsResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new ListServiceAccountsResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type ListServiceAccountsResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const ListServiceAccountsResponseBody$outboundSchema: z.ZodType<
  ListServiceAccountsResponseBody$Outbound,
  z.ZodTypeDef,
  ListServiceAccountsResponseBody
> = z.instanceof(ListServiceAccountsResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));
